<script setup>
import { ref, computed, onBeforeMount } from "vue"
import Breadcrumbs from "@/js/partials/help/guide/Breadcrumbs.vue"
import { useStore } from "vuex"
import { useRoute } from "vue-router"
const props = defineProps({
  contentfulTag: {
    type: String,
    required: true,
  },
})
const route = useRoute()
const loading = ref(true)
</script>
<template>
  <div class="max-w-7xl mx-auto px-4 sm:px-6 pb-10">
    <Breadcrumbs :title="$t(`guides.${contentfulTag}.title`)" />
    <p class="text-3xl font-semibold">
      {{ $t(`guides.${contentfulTag}.title`) }}
    </p>
    <p class="text-gray-500">
      {{ $t(`guides.subtitle`) }}
    </p>
    <hr class="mt-5 mb-10" />
    <router-view :contentful-tag="contentfulTag"></router-view>
  </div>
</template>
